import { db } from 'boot/firebase';
import { collection } from 'firebase/firestore';

import GenericDB from './generic-db';

export default class ProgramBehaviourDataGroupsDB extends GenericDB {
  constructor(programId = null) {
    super('', 'programs.programBehaviourDataGroups');
    this.setProgramId(programId);
  }

  setProgramId(programId) {
    this.programId = programId;
  }

  getCollectionRef() {
    return collection(db, 'programs', this.programId, 'programBehaviourDataGroups');
  }
}
